import IResponseModel, {
  ApiException,
  WebApiMessageSeverity,
} from "../ResponseModel";
import { HttpClient } from "./HttpClient";
import { AxiosResponse } from "axios";

export interface IApiClient {
  // Note: for anyobject you can use Record<string, unknown> instead of Object
  get<T>(
    path: string,
    params?: Record<string, unknown>
  ): Promise<IResponseModel<T>>;
  getFile(path: string, params?: Record<string, unknown>): Promise<any>;
  post<T, U>(
    path: string,
    data: T,
    params?: Record<string, unknown>
  ): Promise<IResponseModel<U>>; // Assumption: post always takes data
  delete<T>(
    path: string,
    params?: Record<string, unknown>
  ): Promise<IResponseModel<T>>;
  put<T, U>(
    path: string,
    data?: T,
    params?: Record<string, unknown>
  ): Promise<IResponseModel<U>>; // Assumption: put always takes data
  patch<T>(
    path: string,
    params?: Record<string, unknown>
  ): Promise<IResponseModel<T>>; // Assumptioin: put always takes data
}

const BASE_URL = import.meta.env.VITE_VUE_APP_WebApiURL;

export function getApiClient(
  headers?: { "Content-Type": string },
  baseURL: string = BASE_URL
): IApiClient {
  return ApiClient.getInstance(baseURL, headers);
}

class ApiClient extends HttpClient implements IApiClient {
  private static _shared?: ApiClient;

  private constructor(baseUrl: string, headers?: { "Content-Type": string }) {
    super(baseUrl, true, headers);
  }

  public static getInstance(
    baseURL: string,
    headers?: { "Content-Type": string }
  ): ApiClient {
    if (headers) return new ApiClient(baseURL, headers);
    if (!this._shared) {
      this._shared = new ApiClient(baseURL);
    }

    return this._shared;
  }

  async get<T>(
    path: string,
    params?: Record<string, unknown>
  ): Promise<IResponseModel<T>> {
    try {
      const response = await this.httpClient.get<IResponseModel<T>>(
        path,
        params
      );
      return response.data;
    } catch (error) {
      if ((error as ApiException).exceptionType) {
        return error as ApiException;
      }
      throw error;
    }
  }
  async getFile(path: string, params?: Record<string, unknown>): Promise<any> {
    try {
      const response = await this.httpClient.get(path, {
        responseType: "blob",
      });

      return response.data;
    } catch (error) {
      if ((error as ApiException).exceptionType) {
        return error as ApiException;
      }
      throw error;
    }
  }
  async post<T, U>(
    path: string,
    data: T,
    params?: Record<string, unknown>
  ): Promise<IResponseModel<U>> {
    try {
      const response = await this.httpClient.post<IResponseModel<U>>(
        path,
        data,
        params
      );
      return response.data;
    } catch (error) {
      if ((error as ApiException).exceptionType) {
        return error as ApiException;
      }
      throw error;
    }
  }
  async delete<T>(
    path: string,
    params?: Record<string, unknown>
  ): Promise<IResponseModel<T>> {
    try {
      const response = await this.httpClient.delete<IResponseModel<T>>(
        path,
        params
      );

      return response.data;
    } catch (error) {
      if ((error as ApiException).exceptionType) {
        return error as ApiException;
      }
      throw error;
    }
  }
  async put<T, U>(
    path: string,
    data?: T,
    params?: Record<string, unknown>
  ): Promise<IResponseModel<U>> {
    try {
      const response = await this.httpClient.put<IResponseModel<U>>(
        path,
        data,
        params
      );
      return response.data;
    } catch (error) {
      if ((error as ApiException).exceptionType) {
        return error as ApiException;
      }
      throw error;
    }
  }

  async patch<T>(
    path: string,

    params?: Record<string, unknown> | undefined
  ): Promise<IResponseModel<T>> {
    try {
      const response = await this.httpClient.patch<IResponseModel<T>>(
        path,
        params
      );

      return response.data;
    } catch (error) {
      if ((error as ApiException).exceptionType) {
        return error as ApiException;
      }
      throw error;
    }
  }

  private processError<T>(error: unknown) {
    return error;
  }

  // private oldProcessError<T>(error: unknown): IResponseModel<T> {
  //   console.log("Error in ApiClient", error);
  //   // @ts-ignore
  //   const exceptionType = error.exceptionType || "System";
  //   // @ts-ignore
  //   const errorStatus = error.status || 500;
  //   // @ts-ignore
  //   if (error.content && error.messages) return error as IResponseModel<T>;

  //   // @ts-ignore
  //   if (error.messages && Array.isArray(error.messages))
  //     // @ts-ignore
  //     return { exceptionType, messages: error.messages };

  //   if (Array.isArray(error)) return { exceptionType, messages: error };
  //   // @ts-ignore
  //   if (error.message && error.response.data.errors)
  //     return {
  //       exceptionType,
  //       messages: [
  //         {
  //           severity: WebApiMessageSeverity.Error,
  //           createdDT: new Date(),
  //           messageId: 1,
  //           title: "A System Error Occurred",
  //           // @ts-ignore
  //           detail: JSON.stringify(error.response.data),
  //           // @ts-ignore
  //           items: [error.message],
  //         },
  //       ],
  //     };
  //   return {
  //     exceptionType,
  //     messages: [
  //       {
  //         severity: WebApiMessageSeverity.Error,
  //         createdDT: new Date(),
  //         messageId: 1,
  //         title: this.getErrorMessage(error),
  //       },
  //     ],
  //   };
  // }
  // private getErrorMessage(error: unknown) {
  //   if (error instanceof Error) return error.message;
  //   else return String(error);
  // }
}
